module.exports = __webpack_public_path__ + "static/media/villager.1b41003d.svg";